import React, { Component } from 'react';
import { Link } from "gatsby";

import { Row, Col } from 'react-bootstrap';


import HandStrengthData from '../../components/HandStrength/HandStrengthData';
import HandStrengthTable from '../../components/HandStrength/HandStrengthTable';
import HandStrengthChart from '../../components/HandStrength/HandStrengthChart';
import Share from '../../Common/Social/Share';
import FbComment from '../../Common/Social/FbComment';
import Layout from '../../Frame/Layout';
import { Helmet } from "react-helmet";
import favicon from '../../images/favicon.ico'


class HandStrength extends Component {
    constructor(props) {
        super(props);

        this.state = {
            handRank: []
        }
    }

    async componentDidMount() {
        const handRank = await HandStrengthData.fetch()

        this.setState({handRank: handRank})
    }

    render() {
        let description = "Discover all 169 Texas Hold'em poker hands ranked by preflop winning odds with our comprehensive calculator. Enhance your game by understanding hand strengths and probabilities."
        let socialMediaTitle = "Texas Hold'em Starting Hand Rankings"
        let socialMediaDescription = description
        let socialMediaImageUrl = "https://app.edge.poker/social_pic/hand_rankings.png"

        return (
            <Layout>
                <Helmet>
                    <title>169 Starting Hand Rankings/Strength - Edge.Poker</title>
                    <meta name="description" content={description}/>
                    <meta name="keywords" content="poker hand rankings，texas holdem hands, poker hand strength, 
                        poker odds hands, good poker odds, best starting hands in poker, worst hand in poker, 
                        texas holdem hand rankings, texas holdem hands in order, texas holdem hands chart"></meta>

                    <meta http-equiv="content-language" content="en-us"></meta>
                    
                    <meta name="twitter:card" content="summary"/>
                    <meta name="twitter:site" content="@EdgePokerApp"/>
                    <meta name="twitter:title" content={socialMediaTitle}/>
                    <meta name="twitter:description" content={socialMediaDescription}/>
                    <meta name="twitter:image" content={socialMediaImageUrl}/>
                
                    <meta name="og:type" content="website"/>
                    <meta name="og:title" content={socialMediaTitle}/>
                    <meta name="og:description" content={socialMediaDescription}/>
                    <meta name="og:image" content="http://app.edge.poker/social_pic/hand_rankings.png"/>
                    <meta name="og:url" content="https://app.edge.poker/hand-strength/"/>  
                    <script async defer src="/sl.js" type='text/javascript'/>
                    <link rel="preload" as="style" href="https://fonts.googleapis.com/css?family=Roboto&display=swap" onload="this.onload=null;this.rel='stylesheet'"></link>  
                    <link rel="icon" href={favicon} />
                </Helmet>

                <Row>
                    <Col xs="0" lg="2"></Col>
                    <Col xs="12" lg="8">
                        <Row>
                            <Col xs="12" className="mb-4 mt-4 text-center">
                                <h1 className="title">Texas Hold'em 169 Starting Hand Rankings/Strength</h1>
                            </Col>
                            <Col xs="12" className="mb-3 mt-3 ">
                                <p>
                                    In this article, we ranked starting hands in Texas Hold'em by the winning chance.
                                </p>
                                <p>
                                    Using our poker odds calculator
                                    engine, we first calculated the "fixed-preflop, post-river" winning probability of all 169 
                                    types of starting hands. Then, we ranked and ordered the starting hands from the best to 
                                    worst in the table and chart below. 
                                </p>
                                <p>
                                    Essentially, we use the winning chance as a measure of hand strength.
                                </p>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12" className="mb-3 mt-3">
                                <h2>Results</h2>
                                <hr></hr>
                            </Col>
                            <Col xs="12" className="mb-2">
                                <h3 className="mb-3" id="hand_rank_table">
                                    Texas Hold'Em Hand Ranking Table
                                </h3>
                                <HandStrengthTable handRankData={this.state.handRank}/>

                                <div className="mt-5">
                                    <h5>Notes</h5>
                                    <ol>
                                        <li>
                                            We define the "fixed-preflop, post-river" winning chance as follows.
                                            The hero's hand is fixed to be the hand of interest. For example, this
                                            could be paired A. Then, in N players game, our simulation deal random 
                                            cards for the (N - 1) other players game.
                                            Next, we would deal all the shared cards randomly up to the river.
                                            We then check if the hero is the winner and keep track how many times has the 
                                            hero won using the fixed hands. 
                                            Finally, we repeat this whole process again for 10,000 times. 
                                            The winning probability is simply = (number of times winning after post river)/10,000
                                            <br></br>
                                            <br></br>
                                        </li>
                                        <li>
                                            "6p. odds" is the "fixed-preflop, post-river" probability of winning a 6-players game. 
                                            It worthwhile to note that we assume no ones folds in the game.
                                            This give rise to the worst case probability or the worst case equity. 
                                            In a real game where players folds, your chance of winning should be higher.
                                            The same interpretation can be applied to the "9p. odds".
                                            <br></br>
                                            <br></br>
                                        </li>
                                        <li>
                                            Why don't we use hand ranges? It is because we don't have real statistics of how frequent
                                            a type of hand is played. We could guess it but then it is becomes subjective. 
                                            If we knew the close-to-real likelihood of each different type of hands being played,
                                            then we could provide non-opinionated estimate of the winning chance.
                                            If you have this type of data, we would be happy to get those statistics
                                            from you.
                                            <br></br>
                                            <br></br>
                                        </li>
                                        <li>
                                            The starting hand ranking or strength is always sorted by the 6-man game winning probability.
                                            Unfortunately, this will cause the 9-man winning chance to be not sorted perfectly.
                                            There are 2 possible reason: (i) We need to do more simulations to improve the accuracy
                                            of the estimated odds, or (ii) Game dynamics in a 9 players game are indeed slightly different.
                                            <br></br>
                                            <br></br>
                                        </li>
                                    </ol>
                                </div>

                                <h3 className="mt-5 mb-4" id="hand_rank_chart">Texas Hold'Em Hand Ranking Chart</h3>
                                <div>
                                    <HandStrengthChart handRankData={this.state.handRank}/>
                                </div>
                                
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" className="mb-3 mt-3">
                                <h2>Analysis</h2>
                                <hr></hr>
                            </Col>
                            <Col xs="12" className="mb-2">
                                <p>
                                    Based on the tabulated data and chart generated, there are a few 
                                    interesting observations to be made. The are listed below:
                                </p>
                                <div className="pt-4 pb-3">
                                    <h3>1. Pair A is best hand</h3>
                                    <p>
                                        There should be no surprise that Pair A is the best hand. Having a pair A, helps you to
                                        easily get the best possible double pair combo or three-of-kind combo. 
                                        While it might be harder to strike straight or flush with it, those
                                        scenarios are typically less likely to happen. Thus, making pair A
                                        better in general.
                                    </p>
                                </div>

                                <div className="pt-4 pb-3">
                                    <h3>
                                        2. Offsuit 72 is the worst hand
                                    </h3>
                                    <p>
                                        This might be less known to people and it could be counter
                                        intuitive. Some might have thought that perhaps Offsuit J2 would
                                        be worse than Offsuit 72. But, that is not the case.
                                    </p>
                                    <p>
                                        To understand why this is the case, we can start thinking about 
                                        what are combinations that are most likely to lead to a winning
                                        combo assuming no one folds. Given any hands, we are more likely
                                        to win with double pair, followed by 3-of-a-kind, straight flush
                                        and so forth.
                                    </p>
                                    <p>
                                        With offsuit 72, we are more likely to win double pair of pair 7 
                                        and pair 2, followed by three-of-a-kind and so on. However, 
                                        it is also worthwhile to note that it is highly like other players
                                        has a better double pair or three-of-a-kind. This bring us to the
                                        next important lesson to learn.
                                    </p>
                                </div>

                                <div className="pt-4 pb-3">
                                    <h3>3. Having a suited, closely connected hand with A, K or Q is better than having pairs that is less than 9</h3>
                                    <p>
                                        If you were to investigate the table or chart, the hand ranked 5th
                                        is Suited AK. What is even more interesting is pairs hand only
                                        took 6 spots from rank 1 to rank 20. Most of the remaining spots 
                                        were taken up by suited, closely connected hands with a high card
                                        like A, K or Q.
                                    </p>
                                    <p>
                                        The reason for this is similar to previous point that we made.
                                        It is more frequent that players will win using double pairs or
                                        3-of-a-kind. Therefore, having a higher card helps to push you 
                                        to a better standing to win.
                                    </p>
                                    <p>
                                        One final note on this topic - Pair 9 is the last pair hand ranked
                                        in the top 20 hands. Playing any other pairs hand may not be as 
                                        good as conventional wisdom might suggest.
                                    </p>
                                </div>

                                <div className="pt-4 pb-3">
                                    <h3>4. Winning chance drops fast within the top 7 ranked hands</h3>
                                    <p>
                                        This is the lesson that really took us by surprised. While developing
                                        our poker odds calculator, we did had a sense that odds of winning
                                        was somewhat asymmetric. But, the chart above really solidify
                                        how much the asymmetry was.
                                    </p>
                                    <p>
                                        Within the top 7 ranked hands, the probability of winning drops really
                                        fast from paired A to paired K and so forth. If you get the 
                                        top 7 hands, you really should work hard to get through the 
                                        preflop.
                                    </p>
                                </div>

                                <div className="pt-4 pb-3">
                                    <h3>5. You are more likely to win a 6 players match than a 9 players one</h3>
                                    <p>
                                        A player with hands that are in the top 7 ranks in a 6 players game have 
                                        a much better chance of winning in a 9 players game.
                                        For example, Paired A has roughly 49.5% preflop winning probability  
                                        in a 6-player game compared to only 35% in a 9-players
                                        game. While 14.5% difference is not as big as it sounds,
                                        it has a significant impact on the pot odds that you will 
                                        need to make a value play. In short, it might be easier to 
                                        make money off a 6 players game rather than a 9 players game.
                                    </p>
                                </div>

                                <div className="pt-4 pb-3">
                                    <h3>6. In a no-folding six players match, your hand range to play is very large</h3>
                                    <p>
                                        This point is not as crucial as other points we have made. But, we find this
                                        observation quite interesting although it is unlikely to happen in real life.
                                    </p>
                                    <p>
                                        Suppose that we are in a no-folding 6 players Texas Hold'Em match. During
                                        every betting session, our pot odds is 5-to-1. This means that for every
                                        $1 we bet, we stand to win $5.
                                    </p>
                                    <p>
                                        Based on this pot odds, our break-even pot equity or winning odds is around 
                                        16.67%. Using the chart above, we can see that we can play any hands better 
                                        than rank 106. This means that players can play 105 types of hands out of 
                                        169 types (59.2% of all types) and still perform better than break even! 
                                        Basically, you have a very large hand range to play in this type of situation.
                                    </p>
                                    <p>
                                        Nonetheless, this is a just-for-fun analysis, which does not happen that 
                                        often in real life. Based on some of our experience playing, it could happen
                                        sometimes during preflop though.
                                    </p>
                                </div>

                                <div className="pt-4 pb-3">
                                    <h3>7. Our hand rankings are similar to Sklansky hand groups</h3>
                                    <p>
                                        <a href="https://en.wikipedia.org/wiki/Texas_hold_%27em_starting_hands#Sklansky_hand_groups" target="_blank">
                                            Sklansky hand groups
                                        </a>&nbsp;
                                        was formulated by David Sklansky and Mason Malmuth. Both of
                                        these old school poker players understand the math very well.
                                        It is no surprise that our hand rankings aligns very well
                                        with their proposed hand groups.
                                    </p>
                                    <p>
                                        Sklansky hand group proposes that Tier 1 group consists of
                                        pair A, pair K, pair Q, pair J and suited AK. These cards are 
                                        essentially ranked 1 to 5 via our Monte Carlo simulation. The same
                                        observation can be made for Sklansky Tier 2 and Tier 3 hand group.
                                    </p>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" className="mb-3 mt-3">
                                <h2>Conclusion</h2>
                                <hr></hr>
                            </Col>
                            <Col xs="12" className="mb-2">
                                <p>
                                    In our analysis of poker hand ranking, we used winning probability as
                                    a metric to rank each starting hands. We show that the top 7 hands
                                    have a significant winning advantage over any other hands, especially 
                                    the best hand - paired A. We hope that poker enthusiasts can used this information 
                                    and <Link to="/">our poker odds calculator</Link> to improve their game.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" className="mb-3 mt-3">
                                <Share shareText="Check out the hand ranking of all 169 types of Texas Hold'Em starting hands."/>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12" className="mb-3 mt-3">
                                <FbComment/>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="0" lg="2"></Col>
                </Row>
            </Layout>
        )
    }
}

export default HandStrength;


// Some google keywords
// texas holdem hands: 100K – 1M
// poker hands: 100K – 1M
// poker hand rankings: 100K – 1M
// texas holdem poker hands: 10K – 100K
// poker hand strength: 1K – 10K
// poker hands odds: 1K – 10K
// good poker hands: 1K – 10K
// worst hand in poker: 1K – 10K
// poker pairs: 1K – 10K
// top poker hands: 1K – 10K
// preflop chart: 1K – 10K
// texas holdem hands chart: 1K – 10K
// poker starting hand chart: 1K – 10K
// best starting hands in poker: 1K – 10K
// texas holdem hand rankings: 1K – 10K
// texas holdem hands in order: 1K – 10K
// texas holdem hands chart: 1K – 10K
// best texas holdem hands: 1K – 10K